import { validateEmail } from "@/helpers";
import { COUNTRIES_DETAILS } from "@/constants";
import { setFieldValue } from "@/stores";
import { useTranslations } from "@/i18n";

/**
 * useAccountDetailsValidation Custom Hook
 *
 * Validates account details form inputs.
 * Handles phone number validation and default prefix setting.
 */
export const useAccountDetailsValidation = () => {
  const t = useTranslations("signUp.consents");
  /**
   * Validates form inputs
   * @param values - form values
   * @returns validation result with error flags
   */
  const validateForm = (values: any) => {
    // Set default phone prefix if not set
    // let phonePrefix = values.phonePrefix;

    // if (!values.phonePrefix) {
    //   phonePrefix = COUNTRIES_DETAILS[173].phone[0];
    //   setFieldValue("phonePrefix", phonePrefix);
    // }

    // Get phone number length for validation
    // const phoneNumberLength = COUNTRIES_DETAILS.find(
    //   (e) => e.phone[0] === phonePrefix
    // )?.phoneLength;

    // console.log(phonePrefix);
    // console.log(phoneNumberLength);

    // Validate form inputs
    const firstNameError = values.firstName.length < 3;
    const lastNameError = values.lastName.length < 3;
    const emailError = !validateEmail(values.email);
    const termsAcceptedError = values.termsAccepted !== true;
    // const phoneNumberError =
    //   values.phoneNumber.replace(/\s/g, "").length !== phoneNumberLength;

    // Return validation result
    return {
      firstNameError: firstNameError ? "First name required" : "",
      lastNameError: lastNameError ? "Last name required" : "",
      emailError: emailError ? "Invalid e-mail" : "",
      phoneNumberError: "", // phoneNumberError ? "Invalid phone length" : "",
      termsAcceptedError: termsAcceptedError
        ? t("termsRequiredError")
        : "",
      hasErrors:
        firstNameError || lastNameError || emailError || termsAcceptedError, // || phoneNumberError,
    };
  };

  return { validateForm };
};
